// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8760) return "static/chunks/8760-495f54af70bced3d.js";
	if (chunkId === 5376) return "static/chunks/5376-ebb23222d81049cd.js";
	if (chunkId === 6347) return "static/chunks/6347-fbcbaa78048940f5.js";
	if (chunkId === 3841) return "static/chunks/3841-824f3a168e54eb3d.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"28":"760af1011c285afe","176":"eab4977229de0101","2200":"5414de93b905af55","3641":"5091ffe3c48fbbed","4246":"10fab1e1fd2a3662","6523":"c60a60e331934164","7886":"fc5ee292cf2fb448","8882":"3d1370ac742d1b95"}[chunkId] + ".js";
};